<template>
  <div>
    <h1>Pressetext</h1>
    <section>
      <p><center><img class="pressImg" src="/images/press.png"/></center></p>
      <p>Wir alle bekommen die <b>Auswirkungen der Corona-Pandemie</b> zu spüren. Aufgrund der bundesweiten Maßnahmen müssen wir unseren Alltag, zwischen Home-Office und Kinderbetreuung, völlig neu organisieren. Doch stellt uns diese Krise nicht nur privat vor neue Herausforderungen, sondern auch ganz besonders Selbstständige, bekommen die Auswirkungen der Pandemie mit voller Härte zu spüren: Abgesagte Veranstaltungen, ausbleibende Aufträge, das Wegbrechen internationaler und nationaler Unternehmenspartner. Durch den flächendeckenden Einbruch der Umsätze entsteht für viele UnternehmerInnen eine existenzbedrohende Situation.
        <br>Doch wir alle wären keine Tabler und Ladies geworden, wenn wir aufgrund einer neuen Herausforderung einfach den Kopf in den Sand stecken würden. Und so heißt es in schwierigen Zeiten einfach noch näher zusammenzurücken, noch mehr für einandern da sein und sich gegenseitig zu unterstützen.</p>
      <p>Ganz im Sinne unseres Mottos <b>"adopt, adapt, improve"</b> hat Tobias Hubold, vom RT 210 Jena, kurzer Hand die Website vonTablern.de | vonLadies.de aufgesetzt.
      <br>Diese Plattform vereint auf einen Blick alle Selbständigen OnlineshopbetreiberInnen, DienstleisterInnen, HerstellerInnen und EntwicklerInnen des RT und Ladies-Universums und macht zum ersten mal die Vielfalt aus Produkte und Angeboten von Tablern und von Ladies sichtbar.
      <br>Bereits nach nur <b>48 Stunden verzeichnete die Plattform mehr als 70 Einträge</b>, mit mehr als 30 Kategorien und verdeutlicht einmal mehr die schiere Vielfalt und Diversität unserer Gemeinschaft.
      <br>Solltest Du also in Zukunft auf der Suche nach einem Geschenk sein, möchtest Dir einfach etwas Guts tun, Euer Tisch oder Circle benötigt eine Auslöse, Du bist als UnternehmerInn auf der Suche nach Ansprechpartnern oder hast sogar einen Auftrag zu vergeben, schau auf <b>vonTablern.de | vonLadies.de</b> vorbei.
      <br>Nutze die Möglichkeit Deine Lebensfreunde direkt und ohne Umwege auch in diesen turbulenten Tagen zu unterstützen.</p>
      <p>Lasst uns Amazon & Co. den Rücken kehren und den Blick einmal mehr auf unsere Nächsten richten und <b>mit geeinten Kräften</b> auch diese schwierigen Zeiten meistern.</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'RTpress',
  data: function() {
    return {
    };
  },
};
</script>

<style scoped type='text/css'>
.pressImg{
  max-width:80%;
  max-height: 400px;
}
</style>